var Member = require('member');
var MemberAdminList = require('memberadminlist');
var MemberHalfOpList = require('memberhalfoplist');
var MemberList = require('memberlist');
var MemberOpList = require('memberoplist');
var MemberOwnerList = require('memberownerlist');
var MemberOperList = require('memberoperlist');
var MemberVoicedList = require('membervoicedlist');
var UserList = require('userlist');


var ChannelMemberList = UserList.extend({
    model: Member,
    initialize: function (models, options) {
        this.connection = options.connection;
        this.channel = options.channel;
        
        this.bind('reset', this.resetMembers, this);
        this.bind('add', this.addMember, this);
        this.bind('remove', this.removeMember, this);
        this.bind('change:mode', this.moveMember, this);
        this.bind('change:nick', this.moveMember, this);
        this.channel.bind('preinit', this.preinit, this);
    },
    preinit: function () {
        this.lists = {};
        _.each(this.connection.getUserModes(), function (mode, category) {
            this.lists[category] = new MemberList([], category, this.connection);
        }, this);
        this.lists.MEMBER = new MemberList([], 'MEMBER', this.connection);
    },
    getList: function (member) {
        return this.lists[member.getModeCategory()];
    },
    getPreviousList: function (member) {
        return this.lists[member.getPreviousModeCategory()];
    },
    resetMembers: function () {
        var toAdd = {};
        var modes = this.connection.getUserModes();
        this.each(function (member) {
            var category = member.getModeCategory(modes);
            if (!toAdd[category]) {
                toAdd[category] = [];
            }
            toAdd[category].push(member);
        }, this);
        _.each(this.lists, function (list, cat) {
            var members = toAdd[cat];
            list.reset(members, {sort: false});
        }, this);
    },
    addMember: function (member, collection, options) {
        var list = this.getList(member);
        list.add(member, options);
    },
    removeMember: function (member, options) {
        var list = this.getList(member);
        list.remove(member, options);
    },
    moveMember: function (member, newMode, options) {
        var prevList = this.getPreviousList(member);
        prevList.remove(member, options);
        this.addMember(member, this, options);
    }
});


module.exports = ChannelMemberList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/channelmemberlist.js
// module id = vxt3
// module chunks = 1